<script lang="ts" setup>
import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { appendImportantStyle } from '@/utils/display/styleUtil';
import { CustomStyle } from '@/appLogic/interfaces/style';

// props
const props = withDefaults(
  defineProps<{
    labelText: string;
    customStyle?: CustomStyle;
  }>(),
  {
    customStyle: undefined,
  }
);

// emits
const emits = defineEmits<{
  (e: 'click'): void;
}>();

// style variables
const Button = styled.button`
  ${{ ...appendImportantStyle(props?.customStyle?.['Button'] ?? {}) }}
`;

//変数
const t = i18n.t;

//関数
const emitClick = () => {
  emits('click');
};
</script>

<template>
  <Button class="bg-blue-500 w-auto h-9 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded" @click="emitClick">
    {{ t(labelText) }}
  </Button>
</template>
